import { Tag } from "antd";
import useEarlyPaymentStatus from "src/hooks/apis/useEarlyPaymentStatus";

/**
 * Promotional badge shown next to the early-payment amount when the user still
 * qualifies for the discounted first early payment. Reads the status itself so it
 * can be dropped anywhere; renders nothing when the promo doesn't apply.
 */
export default function FirstEarlyPaymentBadge({ className, onClick }: { className?: string }) {
  const { data: epStatus } = useEarlyPaymentStatus();

  const firstFee = epStatus?.firstEarlyPaymentFeePercent;
  if (!epStatus?.firstEarlyPaymentEligible || firstFee == null) return null;

  // Normal fee, shown crossed out next to the discounted first-payment fee.
  const regularFee = epStatus?.feePercent;
  const showOriginal = regularFee != null && regularFee > firstFee;
  const discountLabel = firstFee === 0 ? "رایگان" : `${firstFee}٪`;
  console.log({ className })
  return (
    <Tag
      onClick={onClick}
      bordered={false} className={className}>
      <span className="ml-1">کارمزد</span>
      {showOriginal && (
        <span className="line-through text-red-500 opacity-60 ml-1">{regularFee}٪</span>
      )}
      <span className="text-green-500">{discountLabel}</span>
    </Tag>
  );
}
